<template>
  <div class="home">
    <cover-section></cover-section>
    <filters-section></filters-section>
    <home-footer ref="homeFooter"></home-footer>

    <close-button direction="right" v-if="isFiltered" @click.native="resetFilter"></close-button>
  </div>
</template>

<script>
import 'styles/components/home.styl'
import * as PIXI from 'pixi.js'
import Detector from 'utils/Detector'
import Emitter from 'core/Emitter'
import Scene from './classes/Scene'

import CoverSection from 'components/Home/cover.vue'
import FiltersSection from 'components/Home/filters.vue'
import HomeFooter from 'components/Home/footer-home.vue'
import CloseButton from 'components/UI/CloseButton.vue'

export default {
  name: 'home',
  components: {
    CoverSection,
    FiltersSection,
    HomeFooter,
    CloseButton
  },

  data () {
    return {
      isFiltered: false
    }
  },

  created () {
    document.body.classList.add('black')
    window.scrollTo(0, 0)
  },

  mounted () {
    console.log(':: home mounted')
    this.container = this.$el

    this.bindAll()

    this.addListeners()
    this.init()
  },

  beforeDestroy () {
    Emitter.emit('SET_MENU_WHITE')
    this.removeListeners()
  },
  methods: {
    addListeners () {
      Emitter.on('CLICK_FILTER', this.selectFilter)
      Emitter.on('TICK', this.update)
      Emitter.on('RESIZE', this.resize)
    },

    removeListeners () {
      Emitter.removeListener('CLICK_FILTER', this.selectFilter)
      Emitter.removeListener('TICK', this.update)
      Emitter.removeListener('RESIZE', this.resize)
    },

    init () {
      this.ticker = PIXI.ticker.shared
      this.ticker.autoStart = false

      this.$parent.scene = new Scene({
        container: this.container
      })

      if (this.$route.params) {
        if (this.$route.params.goToFilters) {
          this.$parent.scene.goToFilters = true
        }
      }
    },

    bindAll () {
      ['update', 'resize', 'selectFilter']
          .forEach((fn) => (this[fn] = this[fn].bind(this)))
    },

    selectFilter () {
      this.isFiltered = true
    },

    resetFilter () {
      this.isFiltered = false
      Emitter.emit('FILTERS:RESET')
    },

    resizeScroll () {
      if (this.$parent.fakeScroll && this.$parent.scene.isReady) {
        this.offsetHeight = this.$parent.scene.offsetHeight
        this.offsetHeight += this.$parent.scene.coverComp.offsetHeight
        this.offsetHeight += this.$parent.scene.filtersComp.offsetHeight
        this.offsetHeight += this.$parent.scene.homeFooterComp.offsetHeight
        this.$parent.fakeScroll.style.height = `${this.offsetHeight}px`
      }
    },

    resize ({size}) {
      if (!this.$parent.scene) return

      this.$parent.scene.resize(size)

      this.resizeScroll()
    },

    update ({scrollVars, globalTime}) {
      this.$parent.scene.scroll(scrollVars)
      this.$parent.scene.update(globalTime)
    },

    destroyScene () {
      this.$parent.scene.destroy()
      this.$parent.scene = null
    }
  }
}
</script>



/** WEBPACK FOOTER **
 ** index.vue?3475aad0
 **/